import React from 'react';

import classes from './shop-detail-home.module.scss';
import Image from 'next/image';
import { IImage } from '@/schema/image';
import ShopDetailDeliveryInformation from '@/components/shop/shop-detail-delivery-information';
import { Languages } from '@/lib/dictionaries';
import ShopDetailRefund from '@/components/shop/shop-detail-refund';

const chartImageInfo = (locale: Languages) => {
  return {
    url: `https://api.giftifan.com/images/shops/chart-${locale}.jpg`,
    width: 720,
    height: 326,
  };
};

function ShopDetailIntroduce({
  lang,
  title,
  images,
  usageChartImage,
  commonImages,
  productNoticeImages,
}: {
  lang: Languages;
  title: string;
  images: IImage[];
  usageChartImage: boolean;
  commonImages: IImage[];
  productNoticeImages: IImage[];
}) {
  const chartImage = chartImageInfo(lang);

  return (
    <>
      <div className={classes.detailIntroduceGroup}>
        {usageChartImage && (
          <Image
            src={chartImage.url}
            alt={'chart info'}
            width={0}
            height={0}
            sizes="100vw"
            priority={true}
          />
        )}
        {images.length > 0 &&
          images.map((image, index) => (
            <Image
              key={image.url.split('/').pop()}
              src={image.url}
              alt={title}
              width={0}
              height={0}
              sizes="100vw"
              priority={index === 0}
            />
          ))}
        {commonImages.length > 0 &&
          commonImages.map((image, index) => (
            <Image
              key={image.url.split('/').pop()}
              src={image.url}
              alt={title}
              width={0}
              height={0}
              sizes="100vw"
              priority={index === 0}
            />
          ))}
        {lang === 'ko' &&
          productNoticeImages.length > 0 &&
          productNoticeImages.map((image, index) => (
            <Image
              key={image.url.split('/').pop()}
              src={image.url}
              alt={title}
              width={0}
              height={0}
              sizes="100vw"
              priority={index === 0}
            />
          ))}
      </div>
      <ShopDetailDeliveryInformation lang={lang} />
      <ShopDetailRefund lang={lang} />
    </>
  );
}

export default ShopDetailIntroduce;
